import {SchemaField} from 'schemas/fields/SchemaFieldConstants';
import {Schema} from 'schemas/SchemaConstants';
import memoizeLastCall from 'util/memoizeLastCall';

import {StructuredTableColumn} from '../StructuredTableConstants';

export default function findMatchingSchemaFieldForColumn(
  schemas: Array<Pick<Schema, 'allFields'>>,
  column: StructuredTableColumn
): SchemaField | undefined {
  if (column.tagSchemaFieldId == null) {
    return undefined;
  }

  const presentFieldsDict = memoizedGetPresentFieldsDict(schemas);
  return presentFieldsDict[column.tagSchemaFieldId];
}

// Memoize this since findMatchingSchemaFieldForColumn is often called for every cell in a table
// and the schemas are the same for all cells in a table. Shallow equality is sufficient because the schemas
// array should be the same object per render
const memoizedGetPresentFieldsDict = memoizeLastCall(getPresentFieldsDict, {useDeepEquality: false});

function getPresentFieldsDict(schemas: Array<Pick<Schema, 'allFields'>>): Record<string, SchemaField> {
  const presentFieldsDict: Record<string, SchemaField> = {};
  for (const schema of schemas) {
    schema.allFields.forEach((field) => {
      presentFieldsDict[field.id] = field;
    });
  }
  return presentFieldsDict;
}
